/* eslint-disable local/no-small-variable-names */
import { Sparkles } from 'lucide-react';

import { cn } from '@/lib/utils';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/Avatar';

const SIZE_CONFIG = {
  md: {
    avatar: 'h-10 w-10 p-1.5 pt-2.5',
    icon: 'h-5 w-5',
  },
  lg: {
    avatar: 'h-12 w-12 p-2 pt-3',
    icon: 'h-6 w-6',
  },
} as const;

interface StellaAvatarProps {
  size?: keyof typeof SIZE_CONFIG;
  className?: string;
}

export const StellaAvatar = ({ size = 'md', className }: StellaAvatarProps) => {
  const config = SIZE_CONFIG[size];

  return (
    <Avatar
      className={cn(
        'bg-white flex items-center justify-center',
        'drop-shadow-md dark:drop-shadow-md-light',
        config.avatar,
        className
      )}
    >
      <div className="absolute inset-0 rounded-full bg-gradient-primary opacity-85" />
      <AvatarImage
        src="/images/stella-sparkles.svg"
        alt="Stella"
        className="relative z-10"
      />
      <AvatarFallback className="relative z-10 bg-transparent text-on-brand">
        <Sparkles className={config.icon} />
      </AvatarFallback>
    </Avatar>
  );
};
